import { render } from "./ThresholdCard.vue?vue&type=template&id=a20d6878&scoped=true&ts=true&lang=pug"
import script from "./ThresholdCard.vue?vue&type=script&lang=ts"
export * from "./ThresholdCard.vue?vue&type=script&lang=ts"

import "./ThresholdCard.vue?vue&type=style&index=0&id=a20d6878&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20d6878"]])

export default __exports__